export function AffiliateMarketing() {
  return (
    <div className="min-h-screen bg-dark-bg text-white">
      <div className="max-w-5xl mx-auto px-6 py-10 space-y-4">
        <h1 className="text-3xl font-bold">Affiliate / Network Marketing</h1>
        <p className="text-gray-400">
          Intelligence and lead research tailored to affiliate and network marketing organizations.
        </p>
        <div className="bg-card-dark border border-border-dark rounded-xl p-6 text-sm text-gray-300">
          Coming soon. This will include role‑specific search and reporting.
        </div>
      </div>
    </div>
  );
}
